/** The route answers `204` without a body: the payload only names what to reload. */
export type SubjectMemberSavedPayload = { subjectId: number; userId: number };

export type SubjectMemberSavedAction = {
	type: 'SUBJECT_MEMBER_SAVED';
	payload: SubjectMemberSavedPayload;
};

export default (subjectId: number, userId: number): SubjectMemberSavedAction => ({
	type: 'SUBJECT_MEMBER_SAVED',
	payload: { subjectId, userId },
});
